// extracted by mini-css-extract-plugin
export default {"mainDivGeneralInfo":"order_mainDivGeneralInfo__5ZoAv","mainDivGeneralInfoMobile":"order_mainDivGeneralInfoMobile__16DDD"};